module.exports = __webpack_public_path__ + "img/people.76c62c6.webp";